import type { FC } from 'react';
import type { Theme } from '@material-ui/core';
import { experimentalStyled } from '@material-ui/core/styles';
import type { SxProps } from '@material-ui/system';
import { ReactComponent as Imagen } from '../assets/img/logo-Prior.svg';

interface LogoProps {
  sx?: SxProps<Theme>;
}

const LogoRoot = experimentalStyled('svg')();

const LogoNavBar: FC<LogoProps> = (props) => (
  <LogoRoot
    height="52"
    version="1.1"
    viewBox="0 0 166 50"
    width="52"
    {...props}
  >
    <title>Prior</title>
    <Imagen />
  </LogoRoot>
);

export default LogoNavBar;
